import React from 'react';

import StackedBarChart from '../../generic/StackedBarChart';
import { agreementShape } from '../../prop-types';
import {
  agreedBar,
  openBar,
  overspentBar,
  plannedBar,
} from '../utils/get-stacked-bar-chart-items';
import translateBudgetsToProgressBarValues from '../utils/translate-budgets-to-progress-bar-values';

function SimpleAgreementBudgetProgress({ agreement }) {
  const { agreedBudget, plannedBudget, budget } = agreement;

  const barValues = translateBudgetsToProgressBarValues(
    agreedBudget,
    plannedBudget,
    budget,
  );

  const items = [
    agreedBar(barValues.agreed),
    plannedBar(barValues.planned),
    openBar(barValues.open),
    overspentBar(barValues.overspent),
  ];

  return (
    <StackedBarChart
      id={`agreement-${agreement.id}-progress`}
      items={items}
      marker={{ value: agreement.budget }}
      markerHeight={24}
    />
  );
}

SimpleAgreementBudgetProgress.propTypes = {
  agreement: agreementShape.isRequired,
};

export default SimpleAgreementBudgetProgress;
